class AudioStatus {
  READY_FOR_RECORDING = "READY_FOR_RECORDING";
  READY_FOR_REVIEW = "READY_FOR_REVIEW";
  APPROVED = "APPROVED";
  REJECTED = "REJECTED";
}

export default new AudioStatus();
